import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@nexelem/api';

export const productItemVariantsQueryKey = (id: number) => ['variants', id];

export const useProductItemVariants = (id: number) => {
  const api = useAPI();

  return useQuery({
    queryKey: productItemVariantsQueryKey(id),
    queryFn: () => api.getBackItemsP1Variants({ p1: id }),
    enabled: !!id,
  });
};
